import { useState, useEffect } from "react";
import { GoogleSubscriptionModal } from "../../../components/GoogleSubscriptionModal";
import { getAllExisitingAximaDomains, getAximaDomainDetail } from '../../../http/aximaHttp/AximaDomainHttp'
import PageTitle from '../../../components/PageTitle'
import Div from "../../../components/Div";
import Input from "../../../components/Input";
import { Pagination, Stack } from "@mui/material";

export default function AximaDomains() {

  const [domainList, setDomainList] = useState([]);
  // const [isAscending, setIsAscending] = useState(true);
  const [initailDomainList, setInitialDomainList] = useState([])

  const [subscriptionList, setSubscriptionList] = useState(false)

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = domainList.slice(indexOfFirstItem, indexOfLastItem);

  // Calculate total pages
  const totalPages = Math.ceil(domainList.length / itemsPerPage);

  // Change page
  const paginate = (event, value) => {
    setCurrentPage(value);
  };

  const getDomains = async () => {
    const response = await getAllExisitingAximaDomains()
    setDomainList(response.domains)
    setInitialDomainList(response.domains)
  }
  useEffect(() => {

    getDomains()

  }, []);

  function handleSearchDomain(event) {

    const search = event.target.value;
    const filteredList = initailDomainList.filter((domain) => {

      if (domain && domain.customer_domain_name) {

        return domain.customer_domain_name.toLowerCase().includes(search.toLowerCase());
      }
      else {
        return false
      }
    });

    setDomainList(filteredList);

  }


  async function handleDomainClick(domain_id) {
    const googleSubscriptionResponse = await getAximaDomainDetail(domain_id)
    if (googleSubscriptionResponse) {
      console.log(googleSubscriptionResponse.subscription)
      setSubscriptionList({ 'subscription': googleSubscriptionResponse.subscription })
    }
    else {
      alert('No Subscription for this Domain')
    }
    console.log(googleSubscriptionResponse)

  }

  // const sortData = () => {
  //     const sorted = [...initailDomainList].sort((a, b) => {
  //       const dateA = new Date(a.timestamp);
  //       const dateB = new Date(b.timestamp);
  //       return isAscending ? dateA - dateB : dateB - dateA;
  //     });
  //     setDomainList(sorted)
  //     // setSortedData(sorted);
  //     setIsAscending(!isAscending);
  //   };



  return (
    <>
      {subscriptionList ? <GoogleSubscriptionModal show={true.toString()} domain_name={subscriptionList.customer_domain_name} googleLicense={subscriptionList.subscription} open handleClicked={setSubscriptionList} /> : null}

      <PageTitle title='All Axima Domains' />
      <Div className="col-md-12">
        <Div className="page-header-toolbar">

          <Div className="btn-group toolbar-item" role="group" >
            <Input type="text" name="email" id="email" onChange={handleSearchDomain} />
          </Div>

        </Div>
      </Div>

      <Div className="col-md-12 margin_top">
        {currentItems ? <table className="table" border="1">
          <thead>
            <tr>
              <th>Domain Name</th>
              <th>Company Name</th>
              <th>Plan Name</th>
              <th>No of License</th>
              <th>Service Start Date</th>
              <th>Service End Date</th>
            </tr>
          </thead>
          <tbody id="tableBody">
            {currentItems.map((domain) =>

              <tr key={domain.axima_subscription_id}>
                <td><button onClick={() => handleDomainClick(domain.customer_domain_name)} className="btn btn-link ">{domain.customer_domain_name}</button></td>
                <td>{domain.customer_name}</td>
                <td>{domain.plan_name}</td>
                <td>{domain.no_of_lics}</td>
                <td>{domain.service_start_date}</td>
                <td>{domain.service_end_date}</td>
              </tr>
            )

            }
          </tbody>
        </table> :
          <>
            <p style={{ marginTop: '30px' }}>Not Domain Present or Could not fetch Domains</p>
          </>}

        {domainList.length > 0 ?
          <Stack spacing={2}>
            <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate}>

            </Pagination>

          </Stack> : null
        }
      </Div>

    </>
  )
}